import React from "react";
import { IconType } from "../../type/icon_type";
import colors from "../../design/colors";
const IconSend = (props: IconType) => {
  const { width = "24", height = "24", color = colors.gray700, style } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M10.1299 13.8692C9.977 13.7166 9.79481 13.5965 9.59429 13.5162L3.25102 10.9725C3.17528 10.9421 3.11065 10.8893 3.0658 10.8211C3.02096 10.7529 2.99804 10.6727 3.00013 10.5911C3.00222 10.5095 3.02922 10.4305 3.07749 10.3647C3.12577 10.2989 3.19302 10.2495 3.27021 10.223L18.4685 5.0236C18.5393 4.998 18.616 4.99311 18.6896 5.00951C18.7631 5.02591 18.8305 5.06292 18.8838 5.11621C18.9371 5.16949 18.9741 5.23685 18.9905 5.31041C19.0069 5.38396 19.002 5.46066 18.9764 5.53154L13.777 20.7298C13.7505 20.807 13.7011 20.8742 13.6353 20.9225C13.5695 20.9708 13.4905 20.9978 13.4089 20.9999C13.3273 21.002 13.2471 20.979 13.1789 20.9342C13.1107 20.8894 13.0579 20.8247 13.0275 20.749L10.4838 14.4041C10.4031 14.2037 10.2827 14.0218 10.1299 13.8692ZM10.1299 13.8692L18.8812 5.11958"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconSend;
